<script>
import api from "@/axios"
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config"
import Swal from "sweetalert2"

import { produtosChart1, produtosChart2 } from "../components/data-simulados";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Otimizar Carregamento",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, },
  mounted() {
    console.log('mounted carregamento')
    //this.atualizaDataList()
  },
  data() {
    return {
      title: 'Otimizar Carregamento',
      items: [
        {
          text: 'Estoque',
          href: '/movcompras/list',
        },
        {
          text: 'Otimizar Carregamento',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      produtosList: null,
      prodsChart1: produtosChart1,
      prodsChart2: produtosChart2,
      pesqTextFilter: '',
      statusFilter: 'T',
    }
  },

  methods: {
    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/produtos`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data[0])

        this.produtosList = res.data[0]

        this.produtosList.forEach((value) => {
          let imgTrat = value.imgs.split(',')
          value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
        });


        this.title = `(${this.produtosList.length}) Endereçamento de Estoque`
        this.loadingList = false
        this.loadingGraph = false
      });
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/produto`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },


  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" >

      <div class="col-lg-12">

          <div class="card-body">
<!--            <h4 class="card-title">Endereçamentos de estoque</h4>-->
<!--            <p class="card-title-desc">Produtos novos ou perto de seu vencimento</p>-->

            <!-- 16:9 aspect ratio -->
            <div class="ratio ratio-16x9" style="min-height: 1700px;">
              <iframe class="embed-responsive-item" src="https://threed-packing-testes2.onrender.com/"></iframe>
            </div>
          </div>

      </div>

    </div>

  </Layout>
</template>
